<template>
  <div
    class="item"
    :class="['disabled', getWrapperClass]"
    v-on:click="handleOnClick(data, index)">
    <a
      :href="getCampaignLink"
      class="adaptLink">
      <div class="item-picture">
        <imageView
          :image="data.image"
          :desiredSize="productImageSize"
          :useBackEndSize="ifCampaignTypeList"
          :fitByHeight="ifCampaignTypeList"
          class="cover"/>
      </div>
      <div class="item-detail">
        <div class="title">
          <h4 v-if="ifCampaignTypeList">{{ data.activeCampaignName || data.campaignName || (data.product && data.product.name) || ''}}</h4>
          <h4 v-if="!ifCampaignTypeList">{{ data.product && data.product.name }}</h4>
        </div>
        <div v-if="data.product" class="price-box">
          <!-- <div class="old-price" v-if="!data.missedDiscount">{{ data.product.finalPriceOnSale + ' TL' }}</div> -->
          <div class="old-price" v-if="data.product.finalPrice">{{ data.product.finalPrice }} TL</div>
          <div class="new-price" v-if="data.missedDiscount">{{data.missedDiscount}} TL</div>
        </div>
        <div v-else class="price-box">
          <div class="new-price" v-if="data.missedDiscount">{{ data.missedDiscount }} TL</div>
        </div>
      </div>

    </a>
  </div>
</template>

<script>
import imageView from '../../../components/imageView/imageView';

import {isMobileDeviceOrScreen} from '../../../common/agent/agentUtils';

import {PLATFORMS} from '../../../common/constants/constants';
import {PRODUCT_IMAGE_SIZES} from './pastOpportunitiesProductSummaryBoxConstants';

export default {
  name: "pastOpportunitiesProductSummaryBox",
  props: {
    campaignStatus: Boolean,
    data: Object,
    onClick: Function,
    index: Number
  },
  data() {
    return {
      navigationLeftLabel: '<div class="navigationLeftLabel"></div>',
      navigationRightLabel: '<div class="navigationRightLabel"></div>',
      IMAGE_WIDTH: 244,
      IMAGE_HEIGHT: 224,
    };
  },
  computed: {
    ifCampaignTypeList: function () {
      return this.data.campaignType == 'liste';
    },
    getWrapperClass: function () {
      return this.ifCampaignTypeList
          ? 'campaingTypeList'
          : 'campaingTypeProduct';
    },
    getCampaignLink: function() {
      if(this.ifCampaignTypeList && this.data.isHero) {
        return this.data.linkDirection
      }

      return this.ifCampaignTypeList
          ? this.data.campaignLink
          : this.data.product.url;
    },
    productImageSize: function () {
      return isMobileDeviceOrScreen()
          ? PRODUCT_IMAGE_SIZES[PLATFORMS.MOBILE]
          : PRODUCT_IMAGE_SIZES[PLATFORMS.DESKTOP];
    },
  },
  methods: {
    handleOnClick: function(slot, index) {
      this.onClick(slot, index)
    }
  },
  components:{
    imageView,
  }
};
</script>

<style src="./pastOpportunitiesProductSummaryBox.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/view/productSummaryBoxes/pastOpportunitiesProductSummaryBox/pastOpportunitiesProductSummaryBox.vue